import { Injectable } from "@angular/core";
import { IID_FEASABILITY_RESPONSE } from "@common/interfaces/interfaceData";
import { Topics } from "@common/interfaces/topics";
import { ActionService } from "../action/action.service";
import { CrudService } from "../crudService";
import { ProjectEntityStoreStrategy } from "../updateStoreStrategies";
import { IIDFeasabilityResponseQuery } from "./iidFeasabilityResponse.query";
import { IIDFeasabilityResponseStore } from "./iidFeasabilityResponse.store";
import { InterfaceDataService } from "../interfaceDataRegistry";
import { InterfaceName } from "@common/interfaces/issueTypeInterface";

@Injectable({
  providedIn: 'root'
})
@InterfaceDataService(InterfaceName.IID_FEASABILITY_RESPONSE)
export class IIDFeasabilityResponseService extends CrudService<IID_FEASABILITY_RESPONSE, IIDFeasabilityResponseStore, IIDFeasabilityResponseQuery> {
  constructor(
    protected store: IIDFeasabilityResponseStore,
    public query: IIDFeasabilityResponseQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy,
  ) {
    super(
      Topics.IID_FEASABILITY_RESPONSE,
      store,
      query,
      actionService,
      updateStrategy,
    );
  }
}
